export const SonyAmerica = { code: 'SIEA', name: 'SIEA' };
export const SonyEurope = { code: 'SIEE', name: 'SIEE' };
export const SonyAsia = { code: 'SIEH', name: 'SIEJA-Asia' };
export const SonyJapan = { code: 'SIEJ', name: 'SIEJA-Japan' };
